import React, { Fragment } from 'react';
import TimeSeriesTrendChartView from './TimeSeriesTrendChartView';

// Thin route entry — the V3 shell lives inside the view.
const TimeSeriesTrendChartReport = () => (
    <Fragment>
        <TimeSeriesTrendChartView />
    </Fragment>
);

export default TimeSeriesTrendChartReport;
